import React from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiPhone, FiMapPin, FiLinkedin, FiInstagram, FiFacebook } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import { useSiteSettings } from '../../context/SiteSettingsContext';

const Footer = () => {
  const { loaded, visibleFooterLinks } = useSiteSettings();

  // Don't render until settings are loaded
  if (!loaded) return null;

  return (
    <footer className="footer" id="footer">
      <div className="footer__container">
        <div className="footer__grid">
          <div className="footer__col">
            <img src="/logo.webp" alt="Oko Solutions" className="footer__logo" />
            <p className="footer__desc">
              Empowering businesses through cutting-edge digital solutions. 
              Your trusted partner for web development, custom software, and digital marketing.
            </p>
            <div className="footer__socials">
              <a href="https://www.linkedin.com/company/okosolutions/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><FiLinkedin /></a>
              <a href="https://wa.me/917667286609" target="_blank" rel="noreferrer" aria-label="Whatsapp"><FaWhatsapp /></a>
              <a href="https://www.instagram.com/okosolutions_/" target="_blank" rel="noreferrer" aria-label="Instagram"><FiInstagram /></a>
              <a href="https://www.facebook.com/profile.php?id=61577560473270" target="_blank" rel="noreferrer" aria-label="Facebook"><FiFacebook /></a>
            </div>
          </div>

          {visibleFooterLinks.length > 0 && (
            <div className="footer__col">
              <h4>Quick Links</h4>
              {visibleFooterLinks.map((link) => (
                <Link key={link.key} to={link.path}>
                  {link.label}
                </Link>
              ))}
            </div>
          )}

          <div className="footer__col">
            <h4>Services</h4>
            <Link to="/services?category=Web & App Development">Web Development</Link>
            <Link to="/services?category=Custom Software Solutions">Custom Software</Link>
            <Link to="/services?category=Digital Marketing">Digital Marketing</Link>
            <Link to="/services?category=SEO Optimization">SEO Optimization</Link>
            <Link to="/services?category=UI/UX & Branding">UI/UX & Branding</Link>
          </div>

          <div className="footer__col">
            <h4>Contact Info</h4>
            <div className="footer__contact-item">
              <FiMail />
              <span>info@okosolutions.in</span>
            </div>
            <div className="footer__contact-item">
              <FiPhone />
              <span>+91 7667286609</span>
            </div>
            <div className="footer__contact-item">
              <FiMapPin />
              <span>Delhi, India</span>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p>&copy; {new Date().getFullYear()} Oko Solutions. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
